import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { tstm_sso_link } from "../../api/TstmSso";

const Sidebar = () => {
  const [tabActive, setTabActive] = useState({
    settings: false
  });

  const location = useLocation();
  let role = localStorage.getItem('role');
      role = role === 'undefined'||'Branches' ? 'Branch' : role;

  // Open tstm Report Centre with an auto-login SSO link. Opens a new tab so
  // the branch portal session stays intact.
  const openReportCentre = async (e) => {
    e.preventDefault();
    const branch_id = (() => {
      const raw = localStorage.getItem("b_id");
      if (raw == null) return null;
      try { return JSON.parse(raw); } catch { return raw; }
    })();
    const user_id = (() => {
      try {
        return JSON.parse(localStorage.getItem("userData"))?.data?.id;
      } catch { return null; }
    })();
    if (!branch_id || !user_id) {
      toast.error("Please sign in again to open Report Centre.");
      return;
    }
    const win = window.open("", "_blank");
    const res = await tstm_sso_link({ user_id, branch_id, redirect: "/report/center" });
    if (res?.status && res?.data?.url) {
      if (win) win.location = res.data.url;
      else window.location.href = res.data.url;
    } else if (win) {
      win.close();
    }
  };

  useEffect(() => {
    const currentPath = location.pathname;
    if (currentPath.includes("/branch/settings")) {
      setTabActive({ settings: true });
    } else {
      setTabActive({ settings: false });
    }
  }, [location]);

  return (
    <div id="layoutSidenav_nav">
      <div className="left-main-heading">
        <Link to="/branch/dashboard">
          <i className="fa-solid fa-table-cells-large"></i> Dashboard
        </Link>
      </div>
      <div className="accordion" id="accordionExample">

        {/* Students */}
        <div className="accordion-item">
          <div className="accordion-body">
            <nav className="sb-sidenav-menu-nested nav">
              <NavLink
                to="/branch/enroll/student_enroll-list"
                className={({ isActive }) => {
                  const isActivePath =
                    location.pathname.startsWith("/branch/enroll") ||
                    location.pathname.startsWith("/branch/free") ||
                    isActive;
                  return isActivePath ? "nav-link active" : "nav-link";
                }}
              >
                Students
              </NavLink>
            </nav>
          </div>
        </div>

        {/* Classes */}
        <div className="accordion-item">
          <div className="accordion-body">
            <nav className="sb-sidenav-menu-nested nav">
              <NavLink
                to="/branch/class-management/all"
                className={({ isActive }) => {
                  const isActivePath =
                    location.pathname.startsWith("/branch/class-management") ||
                    isActive;
                  return isActivePath ? "nav-link active" : "nav-link";
                }}
              >
                Classes
              </NavLink>
            </nav>
          </div>
        </div>

        {/* Calendar */}
        <div className="accordion-item">
          <div className="accordion-body">
            <nav className="sb-sidenav-menu-nested nav">
              <NavLink
                to="/branch/calendar"
                className={({ isActive }) => {
                  const isActivePath =
                    location.pathname.startsWith("/branch/calendar") || isActive;
                  return isActivePath ? "nav-link active" : "nav-link";
                }}
              >
                Calendar
              </NavLink>
            </nav>
          </div>
        </div>

        {/* Events & Tests */}
        <div className="accordion-item">
          <div className="accordion-body">
            <nav className="sb-sidenav-menu-nested nav">
              <NavLink
                to="/branch/events/all"
                className={({ isActive }) => {
                  const isActivePath =
                    location.pathname.startsWith("/branch/events") || isActive;
                  return isActivePath ? "nav-link active" : "nav-link";
                }}
              >
                Events &amp; Tests
              </NavLink>
            </nav>
          </div>
        </div>

        {/* Tutoring */}
        <div className="accordion-item">
          <div className="accordion-body">
            <nav className="sb-sidenav-menu-nested nav">
              <NavLink
                to="/branch/tutoring"
                className={({ isActive }) => {
                  const isActivePath =
                    location.pathname.startsWith("/branch/tutoring") || isActive;
                  return isActivePath ? "nav-link active" : "nav-link";
                }}
              >
                Tutoring
              </NavLink>
            </nav>
          </div>
        </div>

        {/* Enquiries */}
        <div className="accordion-item">
          <div className="accordion-body">
            <nav className="sb-sidenav-menu-nested nav">
              <NavLink
                to="/branch/enquiries"
                className={({ isActive }) => {
                  const isActivePath =
                    location.pathname.startsWith("/branch/enquiries") || isActive;
                  return isActivePath ? "nav-link active" : "nav-link";
                }}
              >
                Contact
              </NavLink>
            </nav>
          </div>
        </div>

        {/* Attendance */}
        <div className="accordion-item">
          <div className="accordion-body">
            <nav className="sb-sidenav-menu-nested nav">
              <NavLink
                to="/branch/student-attendance"
                className={({ isActive }) => {
                  const isActivePath =
                    location.pathname.startsWith("/branch/student-attendance") ||
                    isActive;
                  return isActivePath ? "nav-link active" : "nav-link";
                }}
              >
                Attendance
              </NavLink>
            </nav>
          </div>
        </div>

        {/* Courses */}
        <div className="accordion-item">
          <div className="accordion-body">
            <nav className="sb-sidenav-menu-nested nav">
              <NavLink
                to="/branch/course/all"
                className={({ isActive }) => {
                  const isActivePath =
                    location.pathname.startsWith("/branch/course") || isActive;
                  return isActivePath ? "nav-link active" : "nav-link";
                }}
              >
                Courses
              </NavLink>
            </nav>
          </div>
        </div>

        {/* Assessments (was Questionnaire List) */}
        <div className="accordion-item">
          <div className="accordion-body">
            <nav className="sb-sidenav-menu-nested nav">
              <NavLink
                to="/branch/question-list"
                className={({ isActive }) => {
                  const isActivePath =
                    location.pathname.startsWith("/branch/question-list") ||
                    isActive;
                  return isActivePath ? "nav-link active" : "nav-link";
                }}
              >
                Assessments
              </NavLink>
            </nav>
          </div>
        </div>

        {/* Teachers */}
        <div className="accordion-item">
          <div className="accordion-body">
            <nav className="sb-sidenav-menu-nested nav">
              <NavLink
                to="/branch/teacher/all"
                className={({ isActive }) => {
                  const isActivePath =
                    location.pathname.startsWith("/branch/teacher") || isActive;
                  return isActivePath ? "nav-link active" : "nav-link";
                }}
              >
                Teachers
              </NavLink>
            </nav>
          </div>
        </div>

        {/* Report Centre (jumps to tstm with auto-login) */}
        <div className="accordion-item">
          <div className="accordion-body">
            <nav className="sb-sidenav-menu-nested nav">
              <a
                href="#"
                className="nav-link"
                onClick={openReportCentre}
              >
                Report Centre <i className="fa-solid fa-arrow-up-right-from-square" style={{ marginLeft: 6, fontSize: 10 }}></i>
              </a>
            </nav>
          </div>
        </div>

        {/* Settings */}
        <div className="accordion-item">
          <h2
            className={`accordion-header ${tabActive?.settings ? "active" : ""}`}
          >
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTen"
              aria-expanded="false"
              aria-controls="collapseTen"
            >
              <i className="fa-solid fa-gears"></i> Settings
            </button>
          </h2>
          <div
            id="collapseTen"
            className={`accordion-collapse collapse ${tabActive?.settings ? "show" : ""}`}
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <nav className="sb-sidenav-menu-nested nav">
                <NavLink
                  to="/branch/settings/users/all"
                  className={({ isActive }) => {
                    const isActivePath =
                      location.pathname.startsWith("/branch/settings/user") || isActive;
                    return isActivePath ? "nav-link active" : "nav-link";
                  }}
                >
                  Users
                </NavLink>
                <NavLink
                  to="/branch/settings/edit"
                  className={({ isActive }) => {
                    const isActivePath =
                      location.pathname.startsWith("/branch/settings/edit") || isActive;
                    return isActivePath ? "nav-link active" : "nav-link";
                  }}
                >
                  Branch Setting
                </NavLink>
              </nav>
            </div>
          </div>
        </div>

        <div className="sb-sidenav-footer">
          <div className="small">Logged in as:</div>
          {role}
        </div>
      </div>
    </div>
  );
};
export default Sidebar;
